import appConfig from '@/config/appConfig.typed';
import appContent from '@/services/content/appContent.typed';

import ageGateCookieService from './ageGateCookieService';

const isAgeGateRequired = (): boolean => {
    const {isAgeGateEnabled} = appConfig.getAgeGateSettings();
    const ageGatePopupContent = appContent.getAgeGatePopupContent();

    if (!isAgeGateEnabled || !ageGatePopupContent) return false;
    return !ageGateCookieService.getIsAgeGateConfirmed();
};

const getAgeYears = (dob: Date): number | undefined => {
    if (!dob) return undefined;

    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();

    if (today.getMonth() < dob.getMonth()) age--;

    return age;
};

const validateAge = (year: number, month: number): boolean => {
    if (!year || !month) return false;
    if (month < 1 || month > 12) return false;
    if (year > new Date().getFullYear()) return false;

    const {minPassingAge} = appConfig.getAgeGateSettings();

    if (!minPassingAge) return false;
    const dob = new Date(year, month - 1);
    const ageYears = getAgeYears(dob);

    return ageYears !== undefined && ageYears >= minPassingAge;
};

const isAgeGateLocked = (): boolean => {
    const lockedUntil = ageGateCookieService.getAgeGateLockedUntil();

    if (!lockedUntil) return false;

    if (Date.now() >= lockedUntil) {
        ageGateCookieService.removeAgeGateLockedUntil();
        return false;
    }

    return true;
};

const getRemainingLockTime = (): number => {
    const lockedUntil = ageGateCookieService.getAgeGateLockedUntil();

    if (!lockedUntil) return 0;

    return Math.max(0, lockedUntil - Date.now());
};

const lockAgeGate = (): void => {
    const {lockTime} = appConfig.getAgeGateSettings();

    if (!lockTime) return;

    const lockedUntil = Date.now() + lockTime * 60000;

    ageGateCookieService.setAgeGateLockedUntil(lockedUntil);
};

export default {
    isAgeGateRequired,
    getAgeYears,
    validateAge,
    getIsAgeConfirmed: ageGateCookieService.getIsAgeGateConfirmed,
    setIsAgeConfirmed: ageGateCookieService.setIsAgeGateConfirmed,
    isAgeGateLocked,
    getRemainingLockTime,
    lockAgeGate,
};
